import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';
import useCreateUser, {
  CreateUserProps,
  translatedCreateUserProps,
} from 'modules/users/hooks/use-create-user';

const CreateUser: React.FC = () => {
  const {getInput} = useFormInputs<CreateUserProps>();

  return (
    <Creation<CreateUserProps>
      titleBar={{title: 'Cadastrar usuário'}}
      onSubmit={useCreateUser}
      inputs={[
        getInput({
          name: 'name',
        }),
        getInput({
          name: 'cpf',
          mask: 'cpf',
        }),
        getInput({
          name: 'phone',
          mask: 'phone',
        }),
        getInput({
          name: 'password',
          secureText: true,
        }),
        getInput({
          name: 'email',
        }),
      ]}
      translationKey={translatedCreateUserProps}
    />
  );
};

export default CreateUser;
